import React, { useState } from 'react';

const DragAndDrop = () => {
  const [draggedData, setDraggedData] = useState(null); // Data for the draggable div
  const [dropMessage, setDropMessage] = useState(null);

  // Handle drag start
  const handleDragStart = (e) => {
    const data = JSON.stringify({ id: 1, name: 'John Doe' });
    e.dataTransfer.setData('object', data); // Pass data to the drop target
    console.log(JSON.parse(e.dataTransfer.getData('object')))
    e.target.style.opacity = '0.5'; // Optional visual feedback
  };

  // Handle drag end
  const handleDragEnd = (e) => {
    e.target.style.opacity = '1';
  };

  // Allow drop
  const handleDragOver = (e) => {
    e.preventDefault(); // Necessary to allow drop
  };

  // Handle drop
  const handleDrop = (e, dropZoneData) => {
    e.preventDefault();
    const data = JSON.parse(e.dataTransfer.getData('object'));
    setDropMessage(data);
    setDraggedData(dropZoneData); // Update the draggable div's data
  };

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      {/* Draggable Box */}
      <div
        draggable
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        style={{
          width: '100px',
          height: '100px',
          backgroundColor: 'blue',
          color: 'white',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'grab',
          margin: '0 auto',
        }}
      >
        Drag Me
        {draggedData && <span>{draggedData.name}</span>}
      </div>

      {/* Drop Area */}
      <div
        onDragOver={handleDragOver}
        onDrop={(e) => handleDrop(e, { id: 2, name: 'Pinny Gaes' })}
        style={{
          marginTop: '20px',
          width: '200px',
          height: '200px',
          border: '2px dashed gray',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f9f9f9',
        }}
      >
        {dropMessage && <span>{dropMessage.id}</span>}
      </div>

            {/* Drop Area */}
            <div
        onDragOver={handleDragOver}
        onDrop={(e) => handleDrop(e, { id: 3, name: 'Orion Vibe' })}
        style={{
          marginTop: '20px',
          width: '200px',
          height: '200px',
          border: '2px dashed gray',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f9f9f9',
        }}
      >
        {dropMessage && <span>{dropMessage.id}</span>}
      </div>
    </div>
  );
};

export default DragAndDrop;
